<div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2">
  <soft-step-header [steps]="steps" [currentIndex]="1" #stepper></soft-step-header>
  <soft-default-header [overline]="stepper.stepText"
    [title]="stepper.current()?.header | translate"
  [subtitle]="stepper.current()?.subHeader | translate"></soft-default-header>
</div>

@if (lagerstandArtikel$ | async; as lagerstandArtikel) {
  @if (lagerstandArtikel.length > 0) {
    @if (lagerstandArtikel[0].artikel?.artikel; as artikel) {
      <div
        class="flex flex-col border border-gray-400 rounded p-3 mt-3">
        <span class="text-xs color-light">{{artikel.nummer}}</span>
        <span class="font-bold">{{artikel.artbez1}}</span>
        <span class="">{{artikel.artbez2}}</span>
        <span class="">{{artikel.artbez3}}</span>
        <span class="">{{artikel.artbez4}}</span>
        <span class="">{{artikel.artbez5}}</span>
      </div>
    }
  }
  <table class="soft-table soft-table-striped mt-4">
    <thead>
      <tr class="!bg-primary text-primary-contrast">
        <th class="!bg-primary">Lager</th>
        <th class="!bg-primary !text-right">Menge</th>
      </tr>
    </thead>
    <tbody>
      @for (current of lagerstandArtikel; track current) {
        <tr>
          <td>{{current.lagerplatz.lagerplatz}}</td>
          <td>
            <div class="flex flex-col items-end justify-center">
              <span>{{current.artikel.menge}} {{current.artikel.einheit.arteh}}</span>
              @if (current.artikel.einheit.id !== current.artikel.einheit_lg.id) {
                <span>
                  {{current.artikel.menge_lg}} {{current.artikel.einheit_lg.arteh}}
                </span>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
@if (loading$ | async) {
  <soft-blocking-loading-spinner class="top-0 right-0"></soft-blocking-loading-spinner>
}
